module.exports = __webpack_public_path__ + "img/image13.fd8a0a16.jpg";